import { useState } from 'react';

export const useConfirmationDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return { isOpen, handleClose, handleOpen };
};
